import type { ReadonlyJSONValue } from "@rocicorp/zero";
import type { ComponentType, ReactNode } from "react";

export type ToolUse = {
  id: string;
  toolName: string;
  input: ReadonlyJSONValue;
  output: ReadonlyJSONValue | null;
  isError: boolean | null;
};

export type ToolResult = {
  id: string;
  output: ReadonlyJSONValue;
  isError: boolean;
};

export type ToolUseProps = {
  toolUse: ToolUse;
  result: ToolResult | null;
  createdAt: number;
  interrupted: boolean;
  data: unknown;
  onProvideResult?: (
    entryId: string,
    output: unknown,
    isError: boolean
  ) => void;
};

export type PendingPromptResultOptions = {
  pauseAfter?: boolean;
  sendStagedAttachments?: boolean;
  approvedPlan?: boolean;
};

type PendingPromptArgs = {
  toolCallId: string;
  input: ReadonlyJSONValue;
  hasStagedAttachments: boolean;
  onResult: (
    output: unknown,
    isError: boolean,
    options?: PendingPromptResultOptions
  ) => Promise<boolean>;
};

export function resolvePromptResult(
  options: PendingPromptResultOptions | undefined,
  hasStagedAttachments: boolean
) {
  const { sendStagedAttachments, approvedPlan, ...resultOptions } =
    options ?? {};
  const sendAttachments = !!sendStagedAttachments && hasStagedAttachments;
  return {
    approvedPlan: !!approvedPlan,
    sendAttachments,
    resultOptions: sendAttachments
      ? { ...resultOptions, pauseAfter: true }
      : resultOptions,
  };
}

export type ChatTool = {
  name: string;
  Header?: ComponentType<ToolUseProps>;
  Body?: ComponentType<ToolUseProps>;
  alwaysExpand?: boolean;
  alwaysLoadOutput?: boolean;
  // When set, clicking the tool row runs this instead of expanding a body.
  onActivate?: (props: ToolUseProps) => void;
  data?: unknown;
  renderPendingPrompt?: (args: PendingPromptArgs) => ReactNode;
};
